module.exports = __webpack_public_path__ + "static/media/hammer.ff1c90de.svg";